export function getSubjectsByCategories(category: string) {
  try {
    switch (category) {
      case 'Mathematics':
        return [1, 2, 3, 4, 5, 6, 7, 8, 9, 25];
      case 'Science':
        return [11, 12, 13, 14, 18, 19, 20, 21, 26, 27];
      case 'English':
        return [15, 24];
      case 'History':
        return [10];
    }
  } catch (error) {
    // console.log(error)
  }
}

export function getDateAndMonth(periodValue: string, date: Date) {
  try {
    return periodValue === 'month'
      ? getMonthName(date) + ' ' + date.getFullYear()
      : date.getDate() + ' ' + getMonthName(date);
  } catch (error) {
    // console.log(error)
  }
}

export function getDateInFormat(currentDate: Date) {
  try {
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  } catch (error) {
    // console.log(error)
  }
}

function getMonthName(date: Date) {
  try {
    const month = date.getMonth();
    switch (month) {
      case 0:
        return 'Jan';
      case 1:
        return 'Feb';
      case 2:
        return 'Mar';
      case 3:
        return 'Apr';
      case 4:
        return 'May';
      case 5:
        return 'June';
      case 6:
        return 'July';
      case 7:
        return 'Aug';
      case 8:
        return 'Sept';
      case 9:
        return 'Oct';
      case 10:
        return 'Nov';
      case 11:
        return 'Dec';
    }
  } catch (error) {
    // console.log(error);
  }
}
